const serviceList = [
  {
    id: 1,
    title: 'Mobile App Design',
    slug: 'the_test_service',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Suspendisse varius enim in eros elementum tristique. Duis cursus,
    mi quis viverra ornare, eros dolor interdum nulla, ut commodo.
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim.`,
    what_we_do: [
      'Apps for iPhone',
      'Apps for iPad',
      'Apps for Samsung',
      'Apps for iMac',
    ],
    example_projects: [1, 2, 3],
    featured: true,
    content: 'mobile-app-design.md',
  },
  {
    id: 2,
    title: 'Mobile App Two',
    slug: 'the_test_two',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Suspendisse varius enim in eros elementum tristique. Duis cursus,
    mi quis viverra ornare, eros dolor interdum nulla, ut commodo.
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim.`,
    what_we_do: [
      'Apps for iPhone',
      'Apps for iPad',
      'Apps for Samsung',
      'Apps for iMac',
    ],
    example_projects: [1, 2, 3],
    featured: true,
    content: 'mobile-app-design.md',
  },
  {
    id: 3,
    title: 'Mobile App Three',
    slug: 'the_test_three',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Suspendisse varius enim in eros elementum tristique. Duis cursus,
    mi quis viverra ornare, eros dolor interdum nulla, ut commodo.
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim.`,
    what_we_do: [
      'Apps for iPhone',
      'Apps for iPad',
      'Apps for Samsung',
      'Apps for iMac',
    ],
    example_projects: [1, 2, 3],
    featured: true,
    content: 'mobile-app-design.md',
  },
]

export default {
  getServices(cb) {
    setTimeout(() => cb(serviceList), 0)
  },
}
